<ng-container *ngIf="!isLoading">
  <div *ngIf="!content[0]?.hero" class="vm-container">
    <div class="diagnostics-steps__heading">
      <div class="vm-col-xs-12">
        <vm-page-heading [routerLinkText]="backLabel" [isDefault]="true" vmRemoveFromView></vm-page-heading>
      </div>
    </div>
  </div>

  <div *ngIf="content[0]?.hero?.breadcrumb" class="vm-container vm-breadcrumb-container">
    <vm-breadcrumb
      [breadcrumbs]="content[0]?.hero?.breadcrumb?.breadcrumbs"
      [breadcrumbNumber]="content[0]?.hero?.breadcrumb?.breadcrumbNumber"
      [theme]="content[0]?.hero?.breadcrumb?.theme"
      [homePage]="content[0]?.hero?.breadcrumb?.homePage">
    </vm-breadcrumb>
  </div>

  <div
    id="tpl-content"
    *ngIf="content[0]"
    [class.hero-short]="isSetting(content[0]?.settings, settings.HeroType, ['short'])">
    <vm-hero-tall
      *ngIf="content[0]?.hero"
      [theme]="content[0]?.hero?.theme"
      [heroHeader]="content[0]?.hero?.heroHeader"
      [buttonText]="content[0]?.hero?.buttonText"
      [btnType]="content[0]?.hero?.btnType"
      [heroText]="content[0]?.hero?.heroText"
      [heroImage]="content[0]?.hero?.heroImage"
      [btnVariant]="content[0]?.hero?.btnVariant"
      [background]="content[0]?.hero?.background"
      [heroMobileImage]="content[0]?.hero?.heroMobileImage"
      [buttonLink]="content[0]?.hero?.buttonLink"
      (okButtonClick)="
        onContentClicked({ type: 'button', event_params: { content_name: content[0]?.hero?.buttonText } })
      "></vm-hero-tall>
    <article>
      <div class="vm-container cozy" *ngIf="content?.length > 1">
        <section class="selectable-cards">
          <h2 *ngIf="content[0]?.items[0].title">
            {{ content[0]?.items[0].title }}
          </h2>
          <vm-markdown
            *ngIf="content[0]?.items[0]?.copy"
            [data]="content[0]?.items[0]?.copy"
            [ngClass]="'selectable-cards__copy'"></vm-markdown>
          <vm-selectable-cards
            [containerItemAlignment]="'space-between'"
            [selectableCards]="content[0]?.items[0].items"
            (selectedCards)="onSelectedCard($event)">
          </vm-selectable-cards>
        </section>
      </div>
      <ng-container *ngFor="let page of content; index as i">
        <div id="{{ page.uid }}" [ngClass]="{ 'topic-items hide': content?.length > 1 }">
          <ng-container
            *ngFor="let item of getNonModalSections(page.items); index as i; first as first; last as last"
            [ngSwitch]="true">
            <div class="vm-container cozy" [class]="addClasses(item?.settings)">
              <vm-divider-line
                *ngIf="checkDividerSettings(item?.settings) === true && (i > first || i < last)"></vm-divider-line>
            </div>
            <div
              [class]="addClasses(item?.settings)"
              [class.vm-container]="
                !isSetting(page?.settings, settings.Width, ['full']) &&
                !isSetting(item?.settings, settings.Width, ['full'])
              "
              [class.cozy]="
                !isSetting(page?.settings, settings.Width, ['full', 'wide']) &&
                !isSetting(item?.settings, settings.Width, ['full', 'wide'])
              ">
              <vm-accordion-section
                *ngSwitchCase="item?.type === type.AccordionLeftAligned"
                (onContentClick)="onContentClicked($event)"
                [data]="item"></vm-accordion-section>
              <vm-article-listing-section
                *ngSwitchCase="item?.type === type.ArticleListing"
                [data]="item"></vm-article-listing-section>
              <vm-did-this-help
                *ngSwitchCase="item?.type === type.ActionCenterAlignWhiteBg"
                [articleId]="didThisHelpArticleId"></vm-did-this-help>
              <vm-countdown-section
                *ngSwitchCase="item?.type === type.CountdownCenterAligned"
                [data]="item"
                [endDate]="item?.endDate">
              </vm-countdown-section>
              <vm-feature-article-section
                *ngSwitchCase="item?.type === type.FeatureArticle"
                (continue)="onContinue($event)"
                [data]="item"></vm-feature-article-section>
              <vm-floating-banner-section *ngSwitchCase="item?.type === type.FloatingBanner" [data]="item">
              </vm-floating-banner-section>
              <vm-links-group-section
                *ngSwitchCase="item?.type === type.LinksLeftAligned"
                [data]="item"></vm-links-group-section>
              <vm-media-tiles-section
                *ngSwitchCase="item?.type === type.MediaTiles"
                [data]="item"
                [isPrototype]="
                  isSetting(item?.settings, settings.MediaTileType, ['prototype'])
                "></vm-media-tiles-section>
              <ng-container *ngSwitchCase="item?.type === type.ModalSection">
                <vm-modal
                  *ngIf="showModal === item.id"
                  [modalType]="modalType.Large"
                  [title]="item.title"
                  [hideHeader]="false"
                  (closeButtonClick)="showModal = ''">
                  <vm-text-section [data]="item" isModal="true"></vm-text-section>
                </vm-modal>
              </ng-container>
              <vm-ordered-list-section
                *ngSwitchCase="item?.type === type.OrderedList"
                [data]="item"></vm-ordered-list-section>
              <vm-postcode-checker-section
                *ngSwitchCase="item?.type === type.PostcodeChecker"
                (setAPILoadingState)="setAPILoadingState($event)"
                [data]="item"></vm-postcode-checker-section>
              <vm-upgrade-360-section
                *ngSwitchCase="item?.type === type.Upgrade360Form"
                (setAPILoadingState)="setAPILoadingState($event)"
                [data]="item"></vm-upgrade-360-section>
              <vm-tab-section *ngSwitchCase="item?.type === type.ExploreCards" [data]="item"></vm-tab-section>
              <vm-text-section
                *ngSwitchCase="
                  item?.type === type.TextSectionLeftAlignedWhiteBg ||
                  item?.type === type.TextSectionLeftAligned ||
                  item?.type === type.TextSectionCenterAlignedWhiteBg ||
                  item?.type === type.TextSectionCenterAligned
                "
                [data]="item"></vm-text-section>
              <vm-tile-section
                *ngSwitchCase="
                  item?.type === type.TileCenterAlignedWhiteBg ||
                  item?.type === type.TileCenterAlignedWhiteBgClick ||
                  item?.type === type.TileLeftAlignedWhiteBg ||
                  item?.type === type.TileLeftAlignedWhiteBgClick ||
                  item?.type === type.TileRightAlignWhiteBg ||
                  item?.type === type.TileRightAlignWhiteBgClick
                "
                [data]="item"></vm-tile-section>
            </div>
          </ng-container>
        </div>
        <ng-container *ngFor="let item of getModalSections(page.items); index as i; first as first; last as last">
          <vm-modal
            *ngIf="showModal === item.id"
            [modalType]="modalType.Large"
            [title]="item.title"
            [hideHeader]="false"
            (closeButtonClick)="showModal = ''">
            <vm-text-section [data]="item" isModal="true"></vm-text-section>
          </vm-modal>
        </ng-container>
      </ng-container>
    </article>
  </div>

  <div class="loading-indicator" *ngIf="showAPILoading">
    <section id="success-panel">
      <div>
        <div>
          <h4>
            <i class="tile-icon fas fa-fw fa-check-circle" [style.color]="'green'"></i>
            <span>Thank you, your upgrade request will be completed shortly.</span>
          </h4>
        </div>
        <br />
        <div>
          <vm-loading-indicator [vmDisableScroll]="true"></vm-loading-indicator>
        </div>
      </div>
    </section>
  </div>
</ng-container>
